const trustIndicators = [
  { label: "Managed IT Services", icon: "ri-settings-4-line" },
  { label: "Cybersecurity", icon: "ri-shield-check-line" },
  { label: "Cloud Solutions", icon: "ri-cloud-line" },
  { label: "Business Continuity", icon: "ri-restart-line" },
];

export default function Hero() {
  return (
    <section
      id="top"
      className="relative min-h-screen flex items-center overflow-hidden bg-foreground-950"
    >
      {/* Background image + overlays */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20navy%20blue%20technology%20network%20visualization%2C%20glowing%20electric%20blue%20and%20cyan%20light%20nodes%20connected%20by%20fine%20luminous%20lines%20forming%20an%20elegant%20mesh%20grid%2C%20deep%20near%20black%20background%20with%20soft%20gradient%20blue%20ambient%20lighting%2C%20subtle%20depth%20of%20field%2C%20premium%20enterprise%20aesthetic%2C%20clean%20geometric%20composition%2C%20modern%20minimal%20futuristic%20infrastructure%20concept%2C%20high%20detail%2C%20sophisticated%20professional%20mood&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="Abstract technology network visualization with blue lighting"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/85" />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/30 to-foreground-950/50" />
      </div>

      {/* Subtle animated glow orbs */}
      <div className="absolute top-1/4 right-1/4 w-72 h-72 rounded-full bg-primary-500/20 blur-3xl animate-pulse-glow pointer-events-none" />
      <div className="absolute bottom-1/4 left-1/4 w-80 h-80 rounded-full bg-accent-400/10 blur-3xl animate-pulse-glow pointer-events-none" />

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 max-w-7xl mx-auto py-32 md:py-40">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 backdrop-blur-sm px-4 py-1.5 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400" />
            <span className="text-xs md:text-sm text-white/80 tracking-wide">
              California-Based IT Consulting &amp; Managed Services
            </span>
          </div>

          <h1 className="font-heading font-extrabold text-white text-4xl md:text-6xl leading-[1.1] tracking-tight">
            Technology That Works.
            <br />
            <span className="bg-gradient-to-r from-accent-300 to-primary-400 bg-clip-text text-transparent">
              Business That Grows.
            </span>
          </h1>

          <p className="mt-6 text-base md:text-lg text-white/75 leading-relaxed max-w-2xl">
            The Tech Consultants LLC provides reliable IT consulting, managed IT services,
            cybersecurity, cloud solutions, communications, and technology strategy to help
            businesses stay secure, productive, and connected.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 text-white px-7 py-3.5 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              Get a Free Consultation
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="#services"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/25 text-white px-7 py-3.5 text-sm font-semibold hover:bg-white/10 backdrop-blur-sm transition-colors duration-200 cursor-pointer"
            >
              Explore Our Services
            </a>
          </div>

          <p className="mt-8 text-sm text-white/60 font-medium tracking-wide">
            Your Technology. Our Expertise. One Reliable Partner.
          </p>

          {/* Trust indicators */}
          <div className="mt-8 flex flex-wrap gap-2.5">
            {trustIndicators.map((t) => (
              <span
                key={t.label}
                className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs text-white/80 backdrop-blur-sm"
              >
                <i className={`${t.icon} text-accent-300 text-sm`} />
                {t.label}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <a
        href="#services"
        aria-label="Scroll to services"
        className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/50 hover:text-white transition-colors cursor-pointer animate-float-slow"
      >
        <i className="ri-arrow-down-line text-2xl" />
      </a>
    </section>
  );
}